import styled from "styled-components";

import { ProfileStoresStyledProps as Props } from "./ProfileStores.types";
import CONSTANTS from "config/constants";
import Modal from "components/global/Modal/Modal";

const { BREAKPOINTS } = CONSTANTS;
const { tablet } = BREAKPOINTS;

const ProfileStoresStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: var(--sizes-navbar-height);
  background-color: var(--palette-gray-s0-l98);
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-areas:
    ".      header ."
    ".      main   ."
    "footer footer footer";

  @media (max-width: ${tablet}px) {
    padding-top: 0;
    grid-template-areas:
      "header header header"
      "main   main   main"
      "footer footer footer";
    background-color: var(--palette-lightgrey-s5-l90);
  }

  .ProfileStores {
    &__header {
      grid-area: header;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__title {
      font-size: 3.6rem;
      margin-bottom: 3.2rem;
      color: var(--palette-black-s0-l20);
      font-weight: 500;
    }

    &__navbar {
      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__go-back {
      width: min-content;
      margin-bottom: 4rem;

      .GoBack {
        &__icon {
          padding: 0.4rem;

          svg {
            width: 1.6rem;
            height: 1.6rem;
          }
        }
      }
    }

    &__info {
      margin-left: 2.4rem;
      width: min-content;

      svg {
        margin-right: 0.8rem;
      }

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__static-map {
      display: flex;
      justify-content: center;
    }

    &__text {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      font-weight: 400;
      width: 100%;
      flex: 1;
      padding-left: 0.4rem;
    }

    &__bottom {
      display: flex;
    }

    &__location {
      flex-direction: column;
      align-items: start !important;
    }

    &__opened,
    &__location,
    &__phone {
      padding-bottom: 2.4rem;
    }

    &__opened,
    &__location,
    &__phone,
    &__time {
      font-size: 1.6rem;
      display: flex;
      align-items: center;
      font-weight: 500;
    }

    &__opened {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 1.6rem;
    }

    &__point {
      width: 0.8rem;
      height: 0.8rem;
      background-color: var(--palette-red-s60-l60);
      border-radius: 90%;
      margin-right: 0.8rem;

      &--active {
        background-color: var(--palette-green-s100-l40);
      }
    }

    &__stores {
      .StorePreview__info,
      .InfoCard__icon-to-right {
        display: none;
      }
    }

    &__main {
      grid-area: main;
      display: grid;
      grid-template-columns: minmax(26rem, 30.4rem) 1fr;
      column-gap: 2.4rem;

      @media (max-width: ${tablet}px) {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }

    &__profile-navigation {
      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__wrapper {
      max-width: 60rem;
      padding: 2.4rem;
      padding-top: 4rem;
      border-radius: 1rem;
      height: max-content;
      overflow: hidden;
      background-color: var(--palette-white);

      @media (max-width: ${tablet}px) {
        max-width: initial;
        min-height: 100%;
        padding: 1.6rem;
        padding-top: 4rem;
        border-radius: 0;
      }
    }

    &__map {
      padding: 0;
      margin-bottom: 2.4rem;

      @media (max-width: ${tablet}px) {
        display: none;
      }

      .StaticMap__image {
        border-radius: 1rem;
      }
    }

    &__list {
      flex: 1;

      .StorePreview {
        &__address {
          white-space: initial;
        }

        .InfoCard__content {
          width: 100%;

          &__value {
            white-space: initial;
          }
        }
      }
    }

    &__image {
      margin: 0 auto;
      margin-bottom: 2.4rem;
      border-radius: 1rem;
    }

    &__footer {
      grid-area: footer;
      padding-top: 3.2rem;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }
  }

  &&& .SearchBar__input {
    padding: 1rem 1.2rem;
    border: none;
    line-height: 2.4rem;

    &:focus {
      box-shadow: none;
    }
  }
`;

export const ModalStyled = styled(Modal)`
  padding: 2rem;
  padding-top: 4.8rem;

  .ProfileStores {
    &__info {
      svg {
        margin-right: 0.8rem;
      }
    }

    &__text {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      width: 100%;
      flex: 1;
      padding-left: 0.4rem;
    }

    &__image {
      margin: 0 auto;
      margin-bottom: 2.4rem;
    }

    &__opened,
    &__location,
    &__phone {
      padding-bottom: 2.4rem;
    }

    &__opened,
    &__location,
    &__phone,
    &__time {
      font-size: 1.6rem;
      display: flex;
      align-items: center;
    }

    &__opened {
      display: flex;
      align-items: center;
      font-size: 1.6rem;
    }

    &__point {
      width: 0.8rem;
      height: 0.8rem;
      background-color: var(--palette-red-s60-l60);
      border-radius: 90%;
      margin-right: 0.8rem;

      &--active {
        background-color: var(--palette-green-s100-l40);
      }
    }
  }
`;

export default ProfileStoresStyled;
